import { getColorWithOpacity } from '@mitsubishi/utils';

export const SUBCATEGORY_COLORS: string[] = [
  'rgb(248, 191, 117)',
  'rgb(197, 175, 175)',
  'rgb(129, 178, 209)',
  'rgb(253, 242, 128)',
  'rgb(210, 172, 211)',
  'rgb(99, 151, 235)',
  'rgb(186, 240, 187)',
  'rgb(177, 177, 177)',
  'rgb(255, 132, 132)',
  'rgb(240, 214, 186)',
];

export const WORKING_CONDITION_OPACITY: number[] = [0.6, 0.4, 0.2, 0.1];
export const STUDY_OPACITY: number[] = [1, 0.8, 0.6, 0.4, 0.2];

export const AVAILABLE_STUDY_COLORS: string[] = generateColorPalette();

export function getWorkingConditionColor(subCategoryIndex: number, wcIndex: number) {
  const color = SUBCATEGORY_COLORS[subCategoryIndex % SUBCATEGORY_COLORS.length];
  const opacity = WORKING_CONDITION_OPACITY[wcIndex % WORKING_CONDITION_OPACITY.length];
  return getColorWithOpacity(color, opacity);
}

export function generateColorPalette(): string[] {
  const palette: string[] = [];

  for (let i = 0; i < STUDY_OPACITY.length; i++) {
    for (let j = 0; j < SUBCATEGORY_COLORS.length; j++) {
      const color = SUBCATEGORY_COLORS[j];
      const opacity = STUDY_OPACITY[i];
      const rgbaColor = color.replace('rgb', 'rgba').replace(')', `, ${opacity})`);
      palette.push(rgbaColor);
    }
  }
  return palette;
}
